import React, { useState } from 'react';
import SEO from '../components/SEO';

const Galerija = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentSection, setCurrentSection] = useState(null);

  // Section 1: Sporto Krantas
  const sportoKrantasImages = [
    '/img/galerija-krantas-1.jpg',
    '/img/galerija-krantas-2.jpg',
    '/img/galerija-krantas-3.jpg',
    '/img/galerija-krantas-4.jpg',
    '/img/galerija-krantas-5.jpg',
    '/img/galerija-krantas-6.jpg',
    '/img/galerija-krantas-7.jpg',
    '/img/galerija-krantas-8.jpg',
    '/img/galerija-krantas-9.jpg',
    '/img/galerija-krantas-10.jpg',
    '/img/galerija-krantas-11.jpg',
    '/img/galerija-krantas-12.jpg',
    '/img/galerija-krantas-13.jpg',
    '/img/galerija-krantas-14.jpg',
    '/img/galerija-krantas-15.jpg',
    '/img/galerija-krantas-16.jpg',
  ];

  // Section 2: Apgyvendinimas
  const apgyvendinimasImages = [
    '/img/galerija-apgyvendinimas-1.jpg',
    '/img/galerija-apgyvendinimas-2.jpg',
    '/img/galerija-apgyvendinimas-3.jpg',
    '/img/galerija-apgyvendinimas-4.jpg',
    '/img/galerija-apgyvendinimas-5.jpg',
    '/img/galerija-apgyvendinimas-6.jpg',
    '/img/galerija-apgyvendinimas-7.jpg',
    '/img/galerija-apgyvendinimas-8.jpg',
    '/img/galerija-apgyvendinimas-9.jpg',
    '/img/galerija-apgyvendinimas-10.jpg',
    '/img/galerija-apgyvendinimas-11.jpg',
    '/img/galerija-apgyvendinimas-12.jpg',
    '/img/galerija-apgyvendinimas-13.jpg',
    '/img/galerija-apgyvendinimas-14.jpg',
  ];

  // Section 3: SPA Centras
  const spaImages = [
    '/img/galerija-spa-1.jpg',
    '/img/galerija-spa-2.jpg',
    '/img/galerija-spa-3.jpg',
    '/img/galerija-spa-4.jpg',
    '/img/galerija-spa-5.jpg',
    '/img/galerija-spa-6.jpg',
    '/img/galerija-spa-7.jpg',
    '/img/galerija-spa-8.jpg',
  ];

  const openLightbox = (sectionImages, index) => {
    setCurrentSection(sectionImages);
    setCurrentIndex(index);
    setSelectedImage(sectionImages[index]);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    setCurrentSection(null);
    document.body.style.overflow = 'auto';
  };

  const goToPrevious = (e) => {
    e.stopPropagation();
    if (!currentSection) return;
    const newIndex = currentIndex === 0 ? currentSection.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
    setSelectedImage(currentSection[newIndex]);
  };

  const goToNext = (e) => {
    e.stopPropagation();
    if (!currentSection) return;
    const newIndex = currentIndex === currentSection.length - 1 ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
    setSelectedImage(currentSection[newIndex]);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') goToPrevious(e);
    if (e.key === 'ArrowRight') goToNext(e);
  };

  // Gallery Section Component
  const GallerySection = ({ title, description, featuredImage, images, reverse = false }) => (
    <section className="py-12 border-b-[3px] border-black bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header with description and featured image */}
        <div className={`flex flex-col ${reverse ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-8 mb-8`}>
          {/* Text content */}
          <div className="lg:w-2/3">
            <h2 className="text-black mb-6 tracking-wide" style={{ fontSize: '24px', fontWeight: 700, WebkitTextStroke: '0.3px' }}>
              {title}
            </h2>
            <p className="text-black text-justify leading-relaxed">
              {description}
            </p>
          </div>
          {/* Featured image */}
          <div className="lg:w-1/3">
            <div 
              className="aspect-[4/3] overflow-hidden cursor-pointer"
              onClick={() => openLightbox(images, 0)}
            >
              <img
                src={featuredImage}
                alt={title}
                className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
              />
            </div>
          </div>
        </div>

        {/* Image Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {images.map((src, index) => (
            <div
              key={index}
              className="aspect-[4/3] overflow-hidden cursor-pointer"
              onClick={() => openLightbox(images, index)}
            >
              <img
                src={src}
                alt={`${title} nuotrauka ${index + 1}`}
                className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );

  return (
    <div>
      <SEO 
        title="Galerija"
        description="Sporto Krantas galerija - nuotraukos iš mūsų poilsio centro, apgyvendinimo, SPA ir pramogų zonų. Apžiūrėkite mūsų erdves."
        keywords="galerija, nuotraukos, sporto krantas, poilsio centras, apgyvendinimas, SPA"
        canonicalUrl="https://sportokrantas.lt/galerija"
      />
      {/* Header Section */}
      <section className="py-12 border-b-[3px] border-black bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-black mb-4 tracking-wide leading-tight text-center" style={{ fontSize: '29.5px', fontWeight: 700, WebkitTextStroke: '0.5px' }}>
            GALERIJA
          </h1>
          <p className="text-black text-center max-w-2xl mx-auto">
            Pasižiūrėkite į mūsų erdves ir aplinką. Spustelėkite ant nuotraukos, kad pamatytumėte ją viso ekrano režimu.
          </p>
        </div>
      </section>

      {/* Section 1: Sporto Krantas */}
      <GallerySection
        title="SPORTO KRANTAS"
        description={'Sporto Krantas – tai vieta, kur judesys susitinka su poilsiu, o akimirkos virsta patirtimis. Čia gimsta šventės, stiprėja komandos, atgyja energija ir kuriami prisiminimai, kurie išlieka ilgiau nei savaitgalis. Tai ne tik erdvė sportui ar poilsiui – tai krantas, prie kurio norisi sugrįžti. Leiskite sužinoti jūsų ketinimus, o mes juos paversime nepamirštame švente ir savo patirtimi pasidalinsime su jumis.'}
        featuredImage="/img/galerija-krantas-1.jpg"
        images={sportoKrantasImages}
      />

      {/* Section 2: Apgyvendinimas */}
      <GallerySection
        title="APGYVENDINIMAS"
        description={'Pramogų ir laisvalaikio centre „Sporto krantas" įrengta 13 šviesių, modernaus dizaino kambarių (dviviečiai ir šeimyniniai), iš kurių atsiveria įspūdingi ežero arba miško vaizdai. Dalis kambarių yra su virtuvėlėmis.'}
        featuredImage="/img/galerija-apgyvendinimas-1.jpg"
        images={apgyvendinimasImages}
        reverse
      />

      {/* Section 3: SPA Centras */}
      <GallerySection
        title="SPA CENTRAS"
        description={'Svečiuodamiesi pas mus nepraleiskite progos pasimėgauti pirties ir atpalaiduojančios sūkurinės vonios malonumais, kur jus apgaubs magiška šiluma, o kerintys vaizdai pro langą natūraliai sulėtins tempą. Geriausiam procedūros efektui pasiūlysime pasinaudoti mūsų profesionalaus pirtininko paslauga, suteiksime galimybę pasimėgauti masažu, pavaišinsime žolelių arbata, kad namo grįžtumėte visapusiškai pailsėję.'}
        featuredImage="/img/galerija-spa-1.jpg"
        images={spaImages}
      />

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-95 z-50 flex items-center justify-center"
          onClick={closeLightbox}
          onKeyDown={handleKeyDown}
          tabIndex={0}
        >
          {/* Close button */}
          <button
            onClick={closeLightbox}
            className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors z-10"
          >
            <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          {/* Previous button */}
          <button
            onClick={goToPrevious}
            className="absolute left-4 top-1/2 -translate-y-1/2 text-white hover:text-gray-300 transition-colors z-10 p-2"
          >
            <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>

          {/* Image */}
          <img
            src={selectedImage}
            alt="Pilno dydžio nuotrauka"
            className="max-h-[90vh] max-w-[90vw] object-contain"
            onClick={(e) => e.stopPropagation()}
          />

          {/* Next button */}
          <button
            onClick={goToNext}
            className="absolute right-4 top-1/2 -translate-y-1/2 text-white hover:text-gray-300 transition-colors z-10 p-2"
          >
            <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>

          {/* Image counter */}
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 text-white text-lg">
            {currentIndex + 1} / {currentSection?.length || 0}
          </div>
        </div>
      )}
    </div>
  );
};

export default Galerija;
